/* eslint-disable react/button-has-type */
import { useRouter } from 'next/router';
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';

import Error from '@/pages/_error';
import AskUsForm from '@/src/askUs/components/AskUsForm';
import FormScrollDown from '@/src/askUs/components/AskUsForm/FormScrollDown';
import Blocks from '@/src/cms/components/CMSPage/CorePage/Blocks';
import HeroContent from '@/src/cms/components/CMSPage/CorePage/HeroContent';
import DesignPage from '@/src/cms/models/DesignPage';
import AdminLink from '@/src/shared/components/AdminLink';
import Container from '@/src/shared/components/Container';
import Layout from '@/src/shared/components/Layout';
import Section from '@/src/shared/components/Section';
import WebLogImage from '@/src/shared/components/WebLogImage';
import withAuthentication from '@/src/shared/components/WithAuthentication';
import { checkAccess } from '@/src/shared/constants';
import request from '@/utils/axios';

const isBrowser = typeof window !== 'undefined';

const AskUs = props => {
  const router = useRouter();
  const {
    query: { subject = null },
  } = router;

  const { messageData = {}, isLoggedIn, role } = props;
  const [types, setTypes] = useState([]);
  const [pagedata, setPageData] = useState({});
  const [loading, setLoading] = useState(true);
  const [isAuthUser, setAuthUser] = useState(isLoggedIn);

  const fetchDesignPage = async () => {
    const response = await request({
      url: `cms/designpage`,
      params: {
        alias: 'askus',
      },
    });
    const { data } = response;
    setPageData(data);
    setLoading(false);
  };

  const fetchTypes = async () => {
    const result = await request({
      url: `shared/getpubliclovs`,
      baseURL: process.env.V2_API_ROOT,
      method: 'POST',
      data: ['askustypes'],
    });
    setTypes(result.data[0].askustypes);
  };

  useEffect(() => {
    fetchDesignPage();
  }, []);

  useEffect(() => {
    if (isLoggedIn) {
      fetchTypes();
    }
  }, [isLoggedIn]);

  const hasAccess = checkAccess(null, role);

  if (isBrowser && !isLoggedIn && !isAuthUser) {
    return <Error status={401} />;
  }
  if (isLoggedIn && !hasAccess) {
    return <Error status={401.4} />;
  }
  if (loading) {
    return null;
  }

  const page = new DesignPage({ ...pagedata, ...messageData });

  return (
    <Layout>
      <AdminLink pageID="507" pageType="core" />
      <HeroContent
        heroData={{
          ...page,
        }}
      />
      {page.Blocks.map(b => (
        <Blocks key={b} blockData={page.entities.Blocks[b]} entities={page.entities} />
      ))}
      <FormScrollDown subject={Boolean(subject)} />
      <Section bgColor="gray">
        <Container size="sm">
          <AskUsForm data={types} defaultSubject={subject} />
        </Container>
      </Section>
      <WebLogImage path="/about/ask-us" pagedata={pagedata} />
    </Layout>
  );
};

export default connect(
  state => {
    const { auth } = state;
    const { isLoggedIn, role } = auth;
    return { isLoggedIn, role };
  },
  null
)(withAuthentication(AskUs));
